import { render, staticRenderFns } from "./HomeDelivery.vue?vue&type=template&id=c01b8bcc&"
import script from "./HomeDelivery.vue?vue&type=script&lang=js&"
export * from "./HomeDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeDelivery.vue"
export default component.exports